/**
 * Internal dependencies
 */
import Front from './front';

export const controller = new Front();